import React from 'react';

const InvoiceFooter = ({ supplier }) => {
  return (
    <div className="footer">
      <div className="signature">
        <p>Authorized Signature</p>
        <p>For {supplier.name}</p>
        <div className="invoice-stamp">
          <img src="/Sign_stamp.png" alt="Vidyutcloud Logo" />
        </div>
      </div>
      <div className="note">
        <p>This is an electronically generated document...</p>
        <p className="po-footer-text">
          {supplier.name || 'Company Name'} | {supplier.address} | {supplier.email} | {supplier.contact}
        </p>
      </div>
    </div>
  );
};

export default InvoiceFooter;